// @Vendors
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Loading extends Component {
  static propTypes = {
    show: PropTypes.bool,
    color: PropTypes.string,
  };
  
  static defaultProps = {
    show: false,
    color: ''
  };

  render() {
    const { show, color } = this.props;
    return show 
      ? (
        <div className={classNames('lds-ring', color)}><div></div><div></div><div></div><div></div></div>
      )
      : null;
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/index.js